// extracted by mini-css-extract-plugin
export var truncate = "_p-0";